import React from 'react'

import * as Styled from './styles/StyledHome'

const Home = props => <Styled.Layout {...props}>{props.children}</Styled.Layout>

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js